export default __webpack_public_path__ + "static/lilnadas-cards-health-1-14e6ee44fa9fb3adda708142216bfff3.png";